import { Controller } from '@hotwired/stimulus'
import { MarkerView } from '@markerjs/markerjs3'

export default class extends Controller {
  static viewer

  getVisibility(){
    return this.element.dataset.visible === 'true'
  }

  toggleVisibility(params = {}){
    const { isVisible, height, width } = params

    const isOverlayVisible = isVisible ?? this.getVisibility()
    
    // Toggle overlay visibility
    this.element.dataset.visible = !isOverlayVisible

    if (height && width){
      this.setupAnnotationViewer({
        height,
        width,
      })
    }
  }

  setupAnnotationViewer(params){
    const { height, width } = params

    if (this.viewer){
      return
    }

    // Create Viewer
    const canvas = document.createElement('canvas');
    canvas.id = 'AnnotationViewer'
    canvas.width = width
    canvas.height = height

    // Fill Viewer (Debugging)
    // let ctx = canvas.getContext("2d")
    // ctx.fillStyle = "green"
    // ctx.fillRect(0, 0, canvas.width, canvas.height)

    // Create Image
    const targetImg = document.createElement('img')
    targetImg.src = canvas.toDataURL('image/png')

    // Setup Editor
    this.viewer = new MarkerView()
    this.viewer.targetImage = targetImg
    // this.viewer.hideLogo()

    // Remove Images
    targetImg.remove()
    canvas.remove()

    this.viewer.addEventListener('viewshow', (e) => {
      this.viewer.shadowRoot.querySelectorAll('.canvas-container')[0].getElementsByTagName('svg')[0].style.margin = 0
    })

    this.element.appendChild(this.viewer)
  }

  modifyViewerSize(params = {}){
    const { height, width } = params
  
    if (this.viewer){
      this.viewer.targetHeight = height
      this.viewer.targetWidth = width

      this.setViewerState(this.annotationData)
    }
  }

  resetViewerState(){
    this.setViewerState({
      height: -1,
      markers: [],
      version: 3,
      width: -1,
    })
  }

  setViewerState(annotationData){
    setTimeout(() => {
      this.annotationData = annotationData
      this.viewer.show(this.annotationData)
    }, 100)
  }
}
